var t = function t(s, d) {
  for (var p in d) {
    var replacer = d[p];

    // eslint-disable-next-line no-param-reassign
    s = s.replace(new RegExp('{' + p + '}', 'g'), replacer.toString());
  }
  return s;
};
export var PATTERNS = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
  USERNAME: /^[a-z][a-z0-9._]*$/i
};
export var isEmail = function isEmail() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ingresa una dirección de correo válida';
  return function (value) {
    if (value && !PATTERNS.EMAIL.test(value)) {
      return msg;
    }
    return undefined;
  };
};
export var isRequired = function isRequired() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Campo Requerido';
  return function (val) {
    if (!val) {
      return msg;
    }
    return null;
  };
};
export var customValidation = function customValidation(pattern, msg) {
  return function (val) {
    if (val && !pattern.test(val)) {
      return msg;
    }
    return undefined;
  };
};
export var length = function length(_ref) {
  var min = _ref.min,
    max = _ref.max,
    field = _ref.field,
    _ref$msg = _ref.msg,
    msg = _ref$msg === void 0 ? 'El campo {field} debe tener entre {min} y {max} caracteres' : _ref$msg;
  return function (val) {
    if (!val) {
      return null;
    }
    if (val.length < min || val.length > max) {
      return t(msg, {
        field: field,
        min: min,
        max: max
      });
    }
    return null;
  };
};
export var matchPassword = function matchPassword(matchName, msg) {
  return function (value, allValues) {
    if (value !== allValues[matchName]) {
      return msg;
    }
    return null;
  };
};